<template>
  <modal id="ajuda-requisito-modal" :titulo="titulo">

    <div class="card">
      <div class="card-body">
        <div v-html="textoExibir"></div>
      </div>
    </div>

  </modal>
</template>

<script>

import Modal from "@/components/Modal.vue";

export default {
  name: "ModalTexto",
  components: {
    Modal
  },

  props: {
    texto: String,
    titulo: String
  },

  computed:{
    textoExibir(){
      return (this.texto || '').split('<a').join('<a target="_blank"');
    }
  },

}
</script>
